import React from "react";
import { ClipboardCheck } from "lucide-react";
import CrudModule from "@/components/CrudModule";

export default function Inspections() {
  return (
    <CrudModule
      title="Inspeções e Checklists"
      subtitle="Inspeções de bancadas, máquinas (NR-12), vasos (NR-13) e áreas"
      icon={ClipboardCheck}
      endpoint="inspections"
      exportKey="inspections"
      testid="inspections"
      columns={[
        { key: "date", label: "Data" },
        { key: "title", label: "Inspeção" },
        { key: "inspection_type", label: "Tipo" },
        { key: "area", label: "Área" },
        { key: "responsible", label: "Responsável" },
        { key: "conformities", label: "Conf." },
        { key: "nonconformities", label: "N/Conf." },
        { key: "status", label: "Status", badge: true },
        { key: "doc", label: "Anexo", file: true, idKey: "document_id" },
      ]}
      fields={[
        { name: "title", label: "Título da inspeção", type: "text", required: true, full: true },
        { name: "inspection_type", label: "Tipo", type: "select", options: ["NR-12 (Máquinas)", "NR-13 (Vasos/PSV)", "Bancada de Testes", "EPI/EPC", "Extintores/Hidrantes", "SPDA", "Ambiental", "Área/5S", "Comportamental"], default: "NR-12 (Máquinas)" },
        { name: "area", label: "Área / Setor", type: "text" },
        { name: "date", label: "Data", type: "date", required: true },
        { name: "responsible", label: "Responsável", type: "text" },
        { name: "status", label: "Status", type: "select", options: ["Concluído", "Em Andamento", "Pendente"], default: "Concluído" },
        { name: "conformities", label: "Itens conformes", type: "number" },
        { name: "nonconformities", label: "Não conformidades", type: "number" },
        { name: "notes", label: "Observações", type: "textarea", full: true },
        { name: "document", label: "Checklist / evidência (upload)", type: "file", idKey: "document_id", nameKey: "document_name", full: true },
      ]}
    />
  );
}
